import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { RouteRuleCreateDrawer } from '../../../../../../../../../../features/fix/route/route-rule-create-drawer';
import { RouteRulesTable } from '../../../../../../../../../../features/fix/route/route-rules-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/oms/routing-rule/_routing-rule/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsOms,
      label: 'Routing Rules',
      order: 2,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsOms>,
  head: () => getPageHead('Routing Rules'),
  component: RoutingRulesList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <RouteRuleCreateDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Create Routing Rule" size="small" />} />
          </RequiresAccess>

          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsOms}
    />
  );
}

function RoutingRulesList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RouteRulesTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
